import './blogs.css'
import ReadMoreButton from './ReadMoreButton'

export default function BlogCard({ img, title, desc, link}) {
    return (
        <div className='blog-card'>
            <div className='blog-card__image-wrapper'>
                <img src={img} alt={title} className='blog-card__image' />
            </div>
            <div className='blog-card__content'>
                <h2 className='blog-card-title'><a href={link} >{ title }</a></h2>
                <div className='bc-description_container'>
                    <p className='blog-card__description'>{ desc }</p>
                </div>
            </div>
            <div className='blog-card__footer'>
                <ReadMoreButton link={link} />
            </div>
        </div>
    )
}